import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SupabaseClient } from '../supabaseClient';

const useRequireProfile = (user) => {
    const navigate = useNavigate();
    const location = useLocation();
    const hasCheckedRef = useRef(false);
    const lastUserIdRef = useRef(null);

    useEffect(() => {
        if (user === undefined) return; // Still loading
        if (user === null) return;       // Not logged in
        if (location.pathname === '/setup-profile') return;

        if (user.id !== lastUserIdRef.current) {
            hasCheckedRef.current = false;
            lastUserIdRef.current = user.id;
        }

        if (hasCheckedRef.current) return; // Already checked for this user

        const checkProfile = async () => {
            const { data, error } = await SupabaseClient
                .from('profiles')
                .select('*')
                .eq('id', user.id)
                .single();

            hasCheckedRef.current = true; // Mark as checked

            if (error || !data) {
                navigate('/setup-profile');
            }
        };

        checkProfile();
    }, [user, navigate, location.pathname]);
};

export default useRequireProfile;